import { useState } from "react";
import Hero from "@/components/site/Hero";
import Philosophy from "@/components/site/Philosophy";
import MobileMenu from "@/components/site/MobileMenu";

export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToPhilosophy = () => {
    const el = document.getElementById("philosophy");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const scrollToWork = () => {
    // Work section not yet built — gracefully scroll to philosophy.
    scrollToPhilosophy();
  };

  return (
    <main data-testid="home-root">
      <Hero
        onMenuOpen={() => setMenuOpen(true)}
        onBegin={scrollToPhilosophy}
        onViewWork={scrollToWork}
      />
      <Philosophy />
      <div className="page-bottom-spacer" aria-hidden="true" />
      <MobileMenu
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        onBegin={() => {
          setMenuOpen(false);
          scrollToPhilosophy();
        }}
      />
    </main>
  );
}
